import React, {useEffect} from 'react';
interface AutoMationSmsProps {
  value: string;
  setFieldValue: (field: string, value: string) => void;
  validateField: (field: string) => void;
}
const AutoMationSms = ({
  setFieldValue,
  value,
  validateField,
}: AutoMationSmsProps) => {
  useEffect(() => {
    if ('OTPCredential' in window) {
      const ac = new AbortController();
      setTimeout(() => {
        // abort after 10 minutes
        ac.abort();
      }, 10 * 60 * 1000);
      navigator.credentials
        .get({
          //@ts-ignore
          otp: {transport: ['sms']},
          signal: ac.signal,
        })
        .then(otp => {
          //@ts-ignore
          if (otp && otp.code) {
            //@ts-ignore
            setFieldValue(value, otp.code);
            validateField(value);
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    }
  }, [setFieldValue, value, validateField]);

  return <></>;
};

export default AutoMationSms;
